"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemConfig = require("@/api/systemConfig.js");
var _validate = require("@/utils/validate");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'integralconfig',
  data: function data() {
    return {
      isShow: false,
      isCreate: 0,
      editData: {},
      formName: '积分配置',
      loading: false
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:integral:get:config'])) this.getFormInfo();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handlerSubmit: (0, _validate.Debounce)(function (data) {
      var _this = this;
      (0, _systemConfig.integralSetConfigApi)(data).then(function (res) {
        _this.getFormInfo();
        _this.$message.success('操作成功');
      });
    }),
    // 获取表单详情
    getFormInfo: function getFormInfo() {
      var _this2 = this;
      this.loading = true;
      (0, _systemConfig.integralGetConfigApi)().then(function (res) {
        _this2.isShow = false;
        Object.assign(_this2.editData, res);
        // this.editData = {
        //   freezeIntegralDay: res.freezeIntegralDay,
        //   integralDeductionMoney: res.integralDeductionMoney,
        //   integralDeductionRatio: res.integralDeductionRatio,
        //   integralDeductionStartMoney: res.integralDeductionStartMoney,
        //   integralDeductionSwitch: res.integralDeductionSwitch,
        //   orderGiveIntegral: res.orderGiveIntegral,
        //   integralFreezeNode: res.integralFreezeNode,
        // };
        _this2.isCreate = 1;
        setTimeout(function () {
          // 让表单重复渲染待编辑数据
          _this2.isShow = true;
        }, 20);
        _this2.loading = false;
      });
    }
  }
};